var _circle, _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSingleLineChatWhiteFilled = function SvgIconSingleLineChatWhiteFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14608_253934",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14608_253934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 16.525V16.6457L7.28536 16.5604L9.04571 14.8H16.75H16.8V14.75V7.25V7.2H16.75H7.25H7.2V7.25V16.525ZM8.7125 13.95H8.69179L8.67714 13.9646L8.05 14.5918V8.05H15.95V13.95H8.7125ZM10 11.4875C10.1374 11.4875 10.2545 11.4412 10.3479 11.3479C10.4412 11.2545 10.4875 11.1374 10.4875 11C10.4875 10.8626 10.4412 10.7455 10.3479 10.6521C10.2545 10.5588 10.1374 10.5125 10 10.5125C9.86263 10.5125 9.74547 10.5588 9.65214 10.6521C9.55882 10.7455 9.5125 10.8626 9.5125 11C9.5125 11.1374 9.55882 11.2545 9.65214 11.3479C9.74547 11.4412 9.86263 11.4875 10 11.4875ZM12 11.4875C12.1374 11.4875 12.2545 11.4412 12.3479 11.3479C12.4412 11.2545 12.4875 11.1374 12.4875 11C12.4875 10.8626 12.4412 10.7455 12.3479 10.6521C12.2545 10.5588 12.1374 10.5125 12 10.5125C11.8626 10.5125 11.7455 10.5588 11.6521 10.6521C11.5588 10.7455 11.5125 10.8626 11.5125 11C11.5125 11.1374 11.5588 11.2545 11.6521 11.3479C11.7455 11.4412 11.8626 11.4875 12 11.4875ZM14 11.4875C14.1374 11.4875 14.2545 11.4412 14.3479 11.3479C14.4412 11.2545 14.4875 11.1374 14.4875 11C14.4875 10.8626 14.4412 10.7455 14.3479 10.6521C14.2545 10.5588 14.1374 10.5125 14 10.5125C13.8626 10.5125 13.7455 10.5588 13.6521 10.6521C13.5588 10.7455 13.5125 10.8626 13.5125 11C13.5125 11.1374 13.5588 11.2545 13.6521 11.3479C13.7455 11.4412 13.8626 11.4875 14 11.4875Z",
    fill: "#9749FF",
    stroke: "#9749FF",
    strokeWidth: 0.1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSingleLineChatWhiteFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-single-line-chat-white-filled.44054737.svg";
export { ForwardRef as ReactComponent };